import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { EmailFindInterface } from '@zaoblako/shared/modules/integration/dtos/email/email-find.dto';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-newsletter-email-sender-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './newsletter-email-sender-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterEmailSenderSingleSelectComponent {
  @Input() public email = <EmailFindInterface>{};
  @Output() public emailChange = new EventEmitter<EmailFindInterface>();

  @Input() public emails: EmailFindInterface[] = [];

  @Input() public styleClass: string;

  @Input() public showClear = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public toEmail(email: any): EmailFindInterface {
    return email as EmailFindInterface;
  }
}
